import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

export default function Menu() {
    return(
        <Container style={{width: 'fit-content'}}>
            <Row style={{textAlign: 'center', justifyContent: 'center', position: 'relative'}}>
                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Omelet
                            </Card.Title>
                            <Card.Text >
                                Two Eggs, Peppers, Onions, Cheese, Broccoli, Mushrooms
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Fried or Scrambled
                            </Card.Title>
                            <Card.Text>
                                Two Eggs, Bacon or Sausage, Hash Brown Cass, Toast
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                
            </Row>




            <Row style={{textAlign: 'center', justifyContent: 'center'}}>
                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Chorizo
                            </Card.Title>
                            <Card.Text>
                                Two Egg scramble, Peppers, Onions, Hash Brown Cass, Toast
                            </Card.Text>
                        </Card.Body>
                    </Card> 
                </Col>
                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                English Muffin
                            </Card.Title>
                            <Card.Text>
                                Toasted, Sausage Gravy, Hash Brown Cass
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>



            <Row style={{textAlign: 'center', justifyContent: 'center'}}>
                <Col xs={12} md={7} lg={6} >
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Meatloaf
                            </Card.Title>
                            <Card.Text>
                                Mashed Potato, Vegetables
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Chicken Noodle Soup
                            </Card.Title>
                            <Card.Text>
                                Thick Noodles, Crackers
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                
            </Row>

            <Row style={{textAlign: 'center', justifyContent: 'center'}}>
                <Col  xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                French Toast
                            </Card.Title>
                            <Card.Text>
                                Bacon or Sausage, Hash Brown Cass
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Grilled Cheese
                            </Card.Title>
                            <Card.Text>
                                Tomato Soup, Crackers
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row style={{textAlign: 'center', justifyContent: 'center'}}>

                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Homemade Classic Chili
                            </Card.Title>
                            <Card.Text>
                                Add Onions, Sour Cream, Shredded Cheddar
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={7} lg={6}>
                    <Card style={{color: '#429aae', width: '100%', marginBottom: '30px', border:'10px #042a2b', fontWeight:'bold', fontFamily:'Fredoka, Geneva, Tahoma, sans-serif'}}>
                        <Card.Body>
                            <Card.Title style={{marginBottom: '0', color: '#ff7f11', fontWeight:'bold', cursor: 'default'}}>
                                Turkey Manhattan
                            </Card.Title>
                            <Card.Text>
                                Mashed Potato, Vegetables
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>



        </Container>
    )
}